import React from 'react'

import type { SelectOption } from '@fourthwall/components'
import { Input, Select } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'

import type {
  FormValues,
  GiftsGivenRule as GiftsGivenRuleType,
} from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'
import { RuleLayout } from '../RuleLayout'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
  options: SelectOption[]
}

export const GiftsGivenRule = ({ form, options }: Props) => (
  <RuleLayout
    top={
      <Select
        value={'GiftsGiven' satisfies GiftsGivenRuleType['type']}
        label="Requirement to earn badge"
        options={options}
        onValueChange={(value) => {
          const newRules = form.values.rules.map((rule) =>
            rule.type === 'GiftsGiven' ? { type: value } : rule,
          )

          form.setFieldValue(FormFields.rules, newRules)
        }}
      />
    }
    bottom={
      <>
        <Input {...form.getFieldProps(FormFields.gifsGivenMin)} label="Min. gifts number" />
        <Input
          {...form.getFieldProps(FormFields.gifsGivenMax)}
          label="Max. gifts number"
          suggestion="Leave empty for infinite"
        />
      </>
    }
    onRemove={() => {
      form.setFieldValue(
        FormFields.rules,
        form.values.rules.filter(
          (rule) => rule.type !== ('GiftsGiven' satisfies GiftsGivenRuleType['type']),
        ),
      )
    }}
  />
)
